export const TEST_ARCHIVES_SET_IS_SHARE_MODAL_VISIBLE =
  "TEST_ARCHIVES_SET_IS_SHARE_MODAL_VISIBLE";

export const TEST_ARCHIVES_PAGINATION_LOADING =
  "TEST_ARCHIVES_PAGINATION_LOADING";
export const TEST_ARCHIVES_PAGINATION_SUCCESS =
  "TEST_ARCHIVES_PAGINATION_SUCCESS";
export const TEST_ARCHIVES_PAGINATION_FAILED =
  "TEST_ARCHIVES_PAGINATION_FAILED";
export const CLEAR_ARCHIVES_PAGINATION_DATA = "CLEAR_ARCHIVES_PAGINATION_DATA";
export const DELETE_TEST = "DELETE_TEST";

export const LAMBDATEST_TEST_LIST_DATA_UPDATE =
  "LAMBDATEST_TEST_LIST_DATA_UPDATE";

export const LAMBDATEST_TEST_LIST_DATA_UPDATE_LIST =
  "LAMBDATEST_TEST_LIST_DATA_UPDATE_LIST";

export const FETCH_FLAXY_TESTS_LIST_LOADING = "FETCH_FLAXY_TESTS_LIST_LOADING";
export const FETCH_FLAXY_TESTS_LIST_SUCCESS = "FETCH_FLAXY_TESTS_LIST_SUCCESS";
export const FETCH_FLAXY_TESTS_LIST_FAILED = "FETCH_FLAXY_TESTS_LIST_FAILED";

export const LAMBDATEST_RENAME_TEST_LOADING = "LAMBDATEST_RENAME_TEST_LOADING";
export const LAMBDATEST_RENAME_TEST_SUCCESS = "LAMBDATEST_RENAME_TEST_SUCCESS";
export const LAMBDATEST_RENAME_TEST_FAILED = "LAMBDATEST_RENAME_TEST_FAILED";
export const LAMBDATEST_UPDATE_TEST_NAME_STATUS =
  "LAMBDATEST_UPDATE_TEST_NAME_STATUS";
export const CYPRESS_TEST_COUNT_FAILED = "CYPRESS_TEST_COUNT_FAILED";
export const CYPRESS_TEST_COUNT_SUCCESS = "CYPRESS_TEST_COUNT_SUCCESS";
export const CYPRESS_TEST_COUNT_LOADING = "CYPRESS_TEST_COUNT_LOADING";

export const TEST_MUTE_STATUS_UPDATE = "TEST_MUTE_STATUS_UPDATE";